export default __webpack_public_path__ + "static/media/iconMarkVentas.0d235c7a.png";